var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceSquint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 90,
    viewBox: "0 0 200 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7936 89.5872C69.5325 89.5872 89.5872 69.5325 89.5872 44.7936C89.5872 20.0548 69.5325 0 44.7936 0C20.0548 0 0 20.0548 0 44.7936C0 69.5325 20.0548 89.5872 44.7936 89.5872Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6542 67.9764C72.1175 67.9764 78.9783 61.1155 78.9783 52.6523C78.9783 44.189 72.1175 37.3281 63.6542 37.3281C55.1909 37.3281 48.3301 44.189 48.3301 52.6523C48.3301 61.1155 55.1909 67.9764 63.6542 67.9764Z",
    fill: "#3D0E6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M155.206 89.5872C179.945 89.5872 200 69.5325 200 44.7936C200 20.0548 179.945 0 155.206 0C130.468 0 110.413 20.0548 110.413 44.7936C110.413 69.5325 130.468 89.5872 155.206 89.5872Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.738 67.9764C145.201 67.9764 152.062 61.1155 152.062 52.6523C152.062 44.189 145.201 37.3281 136.738 37.3281C128.275 37.3281 121.414 44.189 121.414 52.6523C121.414 61.1155 128.275 67.9764 136.738 67.9764Z",
    fill: "#3D0E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceSquint);
export default __webpack_public_path__ + "static/media/face_squint.38ef74bdb6dda9a82ca569dbd926c073.svg";
export { ForwardRef as ReactComponent };